module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_web_003.0ad32c12.png";